export const getCategoryPersonalInformationUrl = (type: string) =>
  `portal-person-info/profile/general/${type}`;

export const getCategoryInternalDocumentUrl = (type: string, screenCode) =>
  `portal-document/document/internal/${screenCode}/general/${type}`;

// danh sách phòng ban
export const getRecruitmentDepartmentEmployee = () =>
  `erp-recruitment/request/department/employee`;

// lấy chức danh MHTC
export const getRecruitmentDepartmentPosition = () =>
  `erp-recruitment/request/department/position`;

// lấy danh sách người liên quan
export const getRelatedPersons = () =>
  `erp-recruitment/request/relate-persons/info`;

export const getCategoryRecruitmentUrl = (type: string) =>
  `erp-recruitment/general/${type}`;

export const getListManagersRecruitmentUrl = (id: string) => {
  return `/erp-recruitment/request/${id}/cbql`;
};
